<template>
  <div>
    <v-list :dense="$vuetify.breakpoint.mobile">
      <BuyoutPaymentInfoListItem
          v-for="(info, index) in buyout.paymentInfos"
          :key="info.id"
          :buyout="buyout"
          :item="info"
          :need-divider="index < buyout.paymentInfos.length - 1"
          @copy="copyNumber"
          @openDialog="showPaymentInfo"
      ></BuyoutPaymentInfoListItem>
      <v-list-item
          v-if="!buyout.paymentInfos.length"
          two-line
          @click="$emit('openAdminMessages')">
        <v-list-item-avatar>
          <v-icon class="red--text">mdi-information-outline</v-icon>
        </v-list-item-avatar>
        <v-list-item-content>
          <v-list-item-title class="red--text">Способы оплаты отсутствуют</v-list-item-title>
          <v-list-item-subtitle>Обратитесь к вашему организатору, чтобы он указал способы оплаты для Личного Кабинета</v-list-item-subtitle>
        </v-list-item-content>
      </v-list-item>
    </v-list>

    <v-dialog
        v-model="dialog"
        eager
        persistent
        scrollable
        width="unset"
    >
      <v-card
          ref="dialog"
          elevation="0"
          :class="{'rounded-0': $vuetify.breakpoint.mobile, 'sm': !$vuetify.breakpoint.mobile}"
      >
        <v-card-title class="headline">
          Способ оплаты
        </v-card-title>
        <v-card-text>
          <v-list
              v-if="currentPaymentInfoData"
              :dense="$vuetify.breakpoint.mobile"
          >
            <v-list-item two-line>
              <v-list-item-avatar>
                <v-icon class="primary white--text">{{currentPaymentInfoData.typeLocalized.icon}}</v-icon>
              </v-list-item-avatar>
              <v-list-item-content>
                <v-list-item-title class="expanded">{{currentPaymentInfoData.title}}</v-list-item-title>
                <v-list-item-subtitle
                    v-html="currentPaymentInfoData.note"
                    class="html-subtitle-big expanded"
                ></v-list-item-subtitle>
              </v-list-item-content>
            </v-list-item>
          </v-list>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
              text
              @click="hidePaymentInfo"
          >
            Закрыть
          </v-btn>
          <v-btn
              v-if="currentPaymentInfoData && currentPaymentInfoData.canCopy"
              color="primary"
              text
              @click="copyNumberFromDialog"
          >
            Скопировать номер
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import BuyoutPaymentInfoListItem from '@/components/BuyoutPaymentInfoListItem'
import {copyToClipboard, fillDialogPosition} from '@/services/utils'
export default {
  name: 'BuyoutPaymentInfoList',
  components: {BuyoutPaymentInfoListItem},
  data () {
    return {
      dialog: false,
      dialogStyles: null,
      currentPaymentInfoData: null
    }
  },
  methods: {
    copyNumber (info) {
      copyToClipboard(info.value)
    },
    copyNumberFromDialog () {
      this.copyNumber(this.currentPaymentInfoData.origin)
      this.dialog = false
    },
    showPaymentInfo (data) {
      this.currentPaymentInfoData = data.opt
      fillDialogPosition(data.event.target, this.$refs.dialog.$el.parentElement)
      this.dialog = true
    },
    hidePaymentInfo () {
      this.currentPaymentInfoData = null
      this.dialog = false
    }
  },
  props: {
    buyout: {
      required: true,
      type: Object
    }
  }
}
</script>

<style scoped>

</style>